export default "__VITE_ASSET__ovXarFQh__"